import { render, staticRenderFns } from "./InboundOrders.vue?vue&type=template&id=562cf506"
import script from "./InboundOrders.vue?vue&type=script&lang=js"
export * from "./InboundOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports